/* eslint-disable import/order */
import React from 'react';
import { Link } from 'react-router-dom';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { Count, getMenuItems } from '@/exceed';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Icon } from 'uikit/icons';
import { Menu } from 'uikit/menus';
import { Typo } from 'uikit/content';
import { Tooltip } from 'uikit/tooltips';

import { getSparkline } from '../helpers/getMockData';

import styles from '../styles/initiative.module.scss';

const Initiative = ({ initiative }) => {
  const { content_count: count } = initiative;
  const editRoute = `/initiatives/edit/${initiative.id}`;

  const menuItems = getMenuItems([
    {
      icon: 'settings',
      isLink: true,
      key: 'properties',
      route: `${editRoute}/properties`,
    },
  ]);

  return (
    <div className={styles.element}>
      <Icon className={styles.icon} icon="insights" />
      <div className={styles.textContainer}>
        <div className={styles.title}>
          <Link to={editRoute}>
            <Typo element="span" variant="b01" weight="medium">
              {initiative.name}
            </Typo>
          </Link>
          <Count tooltip={`${i18n.t('content-count')}: ${count}`} value={count} />
        </div>
        <Typo className={styles.body} color="secondary" variant="s01">
          {initiative.audiences.map((audience) => audience.name).join(', ')}
        </Typo>
      </div>
      <Tooltip className={styles.tooltip} content={i18n.t('sparkline-tooltip')}>
        <img
          alt={i18n.t('sparkline')}
          className={styles.sparkline}
          src={initiative.sparkline_uri || getSparkline()}
        />
      </Tooltip>
      <Menu
        className={styles.menu}
        component={
          <Button
            ariaLabel={i18n.t('more')}
            className={styles.button}
            icon={<MoreHoriz />}
            size="xsmall"
            variant="ghost"
          />
        }
      >
        {menuItems}
      </Menu>
    </div>
  );
};

export default React.memo(Initiative);
